var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", [
    _c("div", { staticClass: "columns is-gapless" }, [
      _vm._m(0),
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("div", { staticClass: "control is-pulled-right" }, [
            _c("div", { staticClass: "is-pulled-right" }, [
              _c(
                "a",
                {
                  staticClass: "button is-small is-success tooltip",
                  attrs: { "data-tooltip": "Add Remarks" },
                  on: {
                    click: function ($event) {
                      return _vm.toggleRemarkModal()
                    },
                  },
                },
                [_vm._m(1), _c("span", [_vm._v("Remarks")])]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "field" },
      [
        _c(
          "bulma-table",
          {
            staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
            attrs: {
              columns: _vm.columns,
              "page-index": _vm.printedFilter.pageIndex,
              "page-size": _vm.printedFilter.pageSize,
              "total-rows": _vm.printedRemarkTotalRows,
              "is-loading": _vm.isTableLoading,
              "sort-column": _vm.printedFilter.sortColumn,
              "sort-order": _vm.printedFilter.sortOrder,
              "show-header": false,
            },
            on: { pageChanged: _vm.onPrintedRemarksPageChange, sort: _vm.sort },
          },
          [
            _vm._l(_vm.pagedPrintedRemarks, function (remark, index) {
              return _c("tr", { key: remark.remarkId }, [
                _c("td", { staticClass: "is-content-width" }, [
                  _c("span", { staticClass: "tag is-info" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$filters.formatDateTimeLocale(
                          remark.remarkDateTime,
                          _vm.$userInfo.locale
                        )
                      )
                    ),
                  ]),
                ]),
                _c("td", { staticClass: "is-remark" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.editPrintedRemarkRowNumber === -1 ||
                            _vm.editPrintedRemarkRowNumber !== index,
                          expression:
                            "editPrintedRemarkRowNumber === -1 || editPrintedRemarkRowNumber !== index",
                        },
                      ],
                    },
                    [_vm._v(_vm._s(remark.remarks))]
                  ),
                  _vm.editPrintedRemarkRowNumber === index
                    ? _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: remark.remarks,
                            expression: "remark.remarks",
                          },
                          {
                            name: "focus-inserted",
                            rawName: "v-focus-inserted",
                          },
                        ],
                        staticClass: "textarea",
                        attrs: { rows: "3" },
                        domProps: { value: remark.remarks },
                        on: {
                          blur: function ($event) {
                            _vm.editPrintedRemarkRowNumber = -1
                          },
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(remark, "remarks", $event.target.value)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c(
                  "td",
                  {
                    staticClass:
                      "has-text-centered is-content-width has-vertical-middle",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "button is-primary is-small is-inverted",
                        on: {
                          click: function ($event) {
                            return _vm.editPrintedRemark(index)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon is-medium" }, [
                          _c("i", {
                            staticClass: "mdi mdi-24px",
                            class: [
                              _vm.editPrintedRemarkRowNumber !== index
                                ? "mdi-lead-pencil"
                                : "mdi-check",
                            ],
                          }),
                        ]),
                      ]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "button is-danger is-small is-inverted",
                        on: {
                          click: function ($event) {
                            return _vm.deleteRemark(
                              index,
                              remark.remarkId,
                              remark.remarkTypeId
                            )
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "icon is-medium" }, [
                          _c("i", { staticClass: "mdi mdi-delete mdi-24px" }),
                        ]),
                      ]
                    ),
                  ]
                ),
              ])
            }),
            _c("template", { slot: "empty" }, [
              _c("section", { staticClass: "section" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "content has-text-grey has-text-centered remark-height",
                  },
                  [
                    _c("span", { attrs: { icon: "icon is-medium" } }, [
                      _c("i", {
                        staticClass:
                          "mdi mdi-20px mdi-dots-horizontal mdi-inactive-color mdi-inactive",
                      }),
                    ]),
                  ]
                ),
              ]),
            ]),
          ],
          2
        ),
        _vm.isRemarkModalActive
          ? _c(
              "remark-modal",
              {
                attrs: {
                  "show-remark": true,
                  "show-printed-remark": true,
                  "show-recurring-remark": true,
                  active: _vm.isRemarkModalActive,
                },
                on: {
                  "update:active": function ($event) {
                    _vm.isRemarkModalActive = $event
                  },
                  add: _vm.addRemarks,
                  cancel: function ($event) {
                    return _vm.toggleRemarkModal()
                  },
                },
              },
              [
                _c("p", { attrs: { slot: "text-title" }, slot: "text-title" }, [
                  _vm._v("Add Return Parts Remarks"),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column" }, [
      _c("p", { staticClass: "title is-6" }, [_vm._v("Printed Remarks")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-18px mdi-plus" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }